module.exports = __webpack_public_path__ + "static/Implants bridge smile after-4183ae1c68987e5254ac33733dc58abc.jpg";